
<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" lg="6">
        <base-card elevation="2">
          <v-card-text>
            <ObjectDetails />

            <!-- <v-btn class="mt-10" text x-small @click="demo">Demo</v-btn> -->
          </v-card-text>
        </base-card>
        <div class="text-subtitle-2 mt-3 secondary-text font-weight-light" v-if="$store.state.confirmed_at === null">
          * Varem alustatud vormiga jätkamiseks sisesta kindlasti sama e-postiaadress, mis eelneval korral.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BuildingCard from "@/components/object/BuildingCard";
import ObjectDetails from "@/components/stepper/steps/ObjectDetails";
import updateRouteQuery from "@/actions/updateRouteQuery";

export default {
  components: {
    ObjectDetails,
    BuildingCard,
  },
  methods: {
    demo() {
      const updatables = {
        email: "email@pintek.ee",
        tel: "55 555 555",
      };
      this.$store.commit("SET", updatables);
      updateRouteQuery(this.$route, updatables);
    },
  },
};
</script>
